import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'formly-field-stepper',
    imports: [CommonModule, MatStepperModule, FormlyModule],
    template: `
        <mat-horizontal-stepper>
            <mat-step
                *ngFor="
                    let step of field.fieldGroup;
                    let index = index;
                    let last = last
                "
            >
                <ng-template matStepLabel>{{ step.props?.label }}</ng-template>
                <formly-field [field]="step"></formly-field>

                <div>
                    <button
                        matStepperPrevious
                        *ngIf="index !== 0"
                        class="btn btn-primary"
                        type="button"
                        >Back</button
                    >

                    <button
                        matStepperNext
                        *ngIf="!last"
                        class="btn btn-primary"
                        type="button"
                        [disabled]="!isValid(step)"
                    >
                        Next
                    </button>

                    <button
                        *ngIf="last"
                        class="btn btn-primary"
                        [disabled]="!form.valid"
                        type="submit"
                        >Submit</button
                    >
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    `
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class FormlyFieldStepper extends FieldType {
    isValid(field: FormlyFieldConfig): boolean | undefined {
        if (field.key) {
            return field.formControl?.valid;
        }

        return field.fieldGroup
            ? field.fieldGroup.every((f) => this.isValid(f))
            : true;
    }
}
